/* eslint-disable */
/**
 * Dummy translation service that mimicks the Translator.trans sytnax
 * that the translation service on the main repo picks up. Here, it
 * just returns the original string untouched.
 */
export const Translator = {
  trans,
  transChoice,
};

function trans(str: string, params?: object, domain?: string): string {
  return str;
}

function transChoice(key: string, number?: number, params?: object, domain?: string): string {
  return `${number}`;
}
